<template>
  <div class="main">
    <back title="精品调酒专业"></back>
    <landingBanner
      landingUrl="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/newwine/banner.png"
    ></landingBanner>
    <div class="content">
     
      <footerForm color="#fff" bag="#a96b04" words="获取学费"></footerForm>
      <indexTitle
        title1="课程学习内容"
        title2="名师执教，精致小班化教学"
      ></indexTitle>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/newwine/part1.png"
      >
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <find></find>
      <indexTitle
        title1="就业前景"
        title2="调酒师不仅酷帅，更有内涵"
      ></indexTitle>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/newwine/part2.png"
      >
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <indexTitle title1="教学作品" title2="高颜值经典作品一览"></indexTitle>
      <van-swipe :autoplay="3000" indicator-color="white">
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/newwine/part3-1.png"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/newwine/part3-2.png"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/newwine/part3-3.png"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
      </van-swipe>
      <find></find>
      <indexTitle title1="名师风采" title2="大师之道·精益求精"></indexTitle>
     <van-swipe :autoplay="3000" indicator-color="white">
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/newwine/part4-1.png"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/newwine/part4-2.png"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
      </van-swipe>
      <indexTitle
        title1="教学环境"
        title2="现代轻文艺的酒吧式调酒教室"
      ></indexTitle>
      <van-swipe :autoplay="3000" indicator-color="white">
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/newwine/part5-1.png"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/newwine/part5-2.png"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/newwine/part5-3.png"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
      </van-swipe>
      <find></find>
       <indexTitle
        title1="技能+证书双丰收"
        title2="励志培养世界酒文化的复合型人才！"
      ></indexTitle>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/newwine/part6.png"
      >
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <indexTitle
        title1="六大教学核心优势"
        title2="小班授课、实操教学模式，塑造学生的创新能力"
      ></indexTitle>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/newwine/part7.png"
      >
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <indexTitle
        title1="成功创业学员"
        title2="迷茫的年纪，成功的选择"
      ></indexTitle>
      <van-swipe :autoplay="3000" indicator-color="#a96b04">
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/newwine/part8-1.png"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/newwine/part8-2.png"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/newwine/part8-3.png"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
      </van-swipe>
      <indexTitle
        title1="优秀就业学员"
        title2="为了同一个梦，欧米奇学子靠行动驱动人生！"
      ></indexTitle>
      <van-swipe :autoplay="3000" indicator-color="#fff">
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/newwine/part9-1.png"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/newwine/part9-2.png"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/newwine/part9-3.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
      </van-swipe>
     
      <footerForm color="#fff" bag="#a96b04" words="点击获取学费报价"></footerForm>
    </div>
    <div class="h20px" style="width:100%;height:20px;"></div>
    <foot></foot>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  components: {
    back: () => import("../../../components/head/back"),
    landingBanner: () => import("../../../components/common/landing-banner"),
    teacher: () => import("../../../components/common/teacher"),
    good8: () => import("../../../components/common/good8"),
    do: () => import("../../../components/common/do"),
    foot: () => import("@/components/foot/foot"),
    indexTitle: () => import("@/components/common/indexTitle"),
    footerForm: () => import("@/components/form/footerForm"),
    find: () => import("@/components/common/find")
  },
  mothods() {}
};
</script>
<style lang="less" scoped>
/deep/ .van-swipe__indicators{
  bottom: 15px;
    left: 10%;
}
.main {
  margin-top: 50px;
}
.content {
  padding: 10px;
}
.title {
  width: 100%;
  height: 65px;
  margin-top: 20px;
  margin-bottom: 10px;
  text-align: center;
}
.title1 {
  width: 100%;
  height: 30px;
  font-weight: 600;
  font-size: 1.5em;
  line-height: 25px;
}
.title2 {
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.title3 {
  width: 100%;
  height: 15px;
  line-height: 15px;
  font-size: 12px;
}

.do-more {
  color: rgb(0, 0, 0, 0.6);
  width: 90%;
  margin-top: 5px;
  line-height: 35px;
  height: 35px;
  background-image: linear-gradient(
    to right,
    rgb(249, 213, 227) 0%,
    rgb(206, 233, 254) 100%
  );
  border: none;
}
</style>
